import { r as registerInstance, h, H as Host, g as getElement } from './index-41410303.js';
import { E as EventService } from './event-service-b352bb3b.js';
import { I as InternalEventType } from './internal-event-types-8598fbfb.js';
import './internal-download-as-event-b0b1e7d3.js';
import './internal-dropdown-value-selected-event-310f527b.js';

const copyResourceLinkButtonCss = ".copy-resource-link-button a.ri-links-line:hover{text-decoration:none}";

const CopyResourceLinkButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.uri = undefined;
    this.classes = undefined;
  }
  onButtonClick() {
    EventService.emitFromInnerElement(this.hostElement, InternalEventType.INTERNAL_SHOW_RESOURCE_COPY_LINK_DIALOG_EVENT, { copyLink: this.uri });
  }
  render() {
    const classList = `copy-resource-link-button ${this.classes || ''}`;
    return (h(Host, { class: classList }, h("a", { class: "ri-links-line", href: "#", onClick: () => this.onButtonClick() })));
  }
  get hostElement() { return getElement(this); }
};
CopyResourceLinkButton.style = copyResourceLinkButtonCss;

export { CopyResourceLinkButton as copy_resource_link_button };
